module.exports = __webpack_public_path__ + "static/img/product_banner_12_zh.20f60e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_12_zh.png
// module id = /50d
// module chunks = 34